import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import { DietaryPreference } from "../../../../models";
import { DeleteDietaryPreference, UpdateDietaryPreference } from "./buttons";

export default function DietaryPreferencesTable({
  dietaryPreferences,
}: {
  dietaryPreferences: DietaryPreference[];
}) {
  return (
    <Container className=" max-w-2xl">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {dietaryPreferences?.map((dietaryPreference) => (
          <div
            key={dietaryPreference.id}
            className="mb-2 w-full rounded-md bg-white p-4"
          >
            <h2 className="text-lg font-semibold">{dietaryPreference.name}</h2>            
            <div className="flex items-center justify-between pb-4 mt-2">
              {dietaryPreference.id ? (
                <div className="w-full flex items-center justify-center gap-2">
                  <UpdateDietaryPreference id={dietaryPreference.id.toString()} />
                  <DeleteDietaryPreference id={dietaryPreference.id.toString()} />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>            
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3 text-center">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {dietaryPreferences.map((dietaryPreference) => (
            <tr key={dietaryPreference.id} className="border-b">              
              <td className="px-6 py-4 font-medium">{dietaryPreference.name}</td>
              <td className="px-6 py-4">
                {dietaryPreference.id ? (
                  <div className="flex items-center justify-center gap-2">
                    <UpdateDietaryPreference id={dietaryPreference.id.toString()} />
                    <DeleteDietaryPreference id={dietaryPreference.id.toString()} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}



